module.exports = __webpack_public_path__ + "img/icon_lighting_shebei_big.771f3141.png";